import { render, staticRenderFns } from "./AccessInvitesList.vue?vue&type=template&id=97b8d44a&scoped=true&"
import script from "./AccessInvitesList.vue?vue&type=script&lang=js&"
export * from "./AccessInvitesList.vue?vue&type=script&lang=js&"
import style0 from "./AccessInvitesList.vue?vue&type=style&index=0&id=97b8d44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b8d44a",
  null
  
)

export default component.exports